import { render } from "./TheHoatDongDuLich.vue?vue&type=template&id=083e6c9d"
import script from "./TheHoatDongDuLich.vue?vue&type=script&lang=js"
export * from "./TheHoatDongDuLich.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__